import { render, staticRenderFns } from "./ImportTextDropdownText.vue?vue&type=template&id=4727ee40&scoped=true&"
import script from "./ImportTextDropdownText.vue?vue&type=script&lang=js&"
export * from "./ImportTextDropdownText.vue?vue&type=script&lang=js&"
import style0 from "./ImportTextDropdownText.vue?vue&type=style&index=0&id=4727ee40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4727ee40",
  null
  
)

export default component.exports